import React, { ReactNode, useEffect, useMemo } from 'react'
import Paper from '@mui/material/Paper'
import { Loader } from '../../../shared/ui/Loader/Loader'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import { MuiTableHead } from '../../../shared/ui/MuiTableHead/MuiTableHead'
import TableBody from '@mui/material/TableBody'
import { StyledTableRow } from '../../../shared/ui/StyledTableRow/StyledTableRow'
import TableCell from '@mui/material/TableCell'
import { NoData } from '../../../shared/ui/NoData/NoData'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectClientLabels } from '../model/selectors/selectClientLabels'
import { Column } from '../../../shared/types/Column'
import { LabelChip } from '../../../entities/ClientLabel/ui/LabelChip'
import { ClientLabelWithId } from '../../../entities/ClientLabel'
import { ClientLabelsActions } from './ClientLabelsActions'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { fetchClientLabels } from '../model/services/fetchClientLabels'
import { selectIsLoading } from '../model/selectors/selectIsLoading'
import { ClientLabelWithLabelView } from '../model/types/ClientLabelsSchema'

const columns: Column[] = [
	{ id: 'labelName', label: 'Name ', minWidth: 50 },
	{ id: 'labelView', label: 'Label view', minWidth: 50 },
	{ id: 'labelId', label: 'ID', minWidth: 50 }
]

export const DisplayClientLabels = () => {
	const dispatch = useAppDispatch()
	const clientLabelsLoading = useAppSelector(selectIsLoading)
	const clientLabels = useAppSelector(selectClientLabels)

	const labels: Array<ClientLabelWithLabelView> = useMemo(() => clientLabels.map(label => ({
			...label,
			labelView: (
				<LabelChip
					labelColor={label.labelColor}
					labelName={label.labelName}
				/>
			)
		})
	), [clientLabels])

	useEffect(() => {
		dispatch(fetchClientLabels())
	}, [])

	return (
		<Paper
			elevation={3}
			sx={{ width: '100%', border: '1px solid lightgrey' }}
		>
			{clientLabelsLoading ? (
				<Loader />
			) : clientLabels && !!clientLabels.length ? (
				<TableContainer>
					<Table aria-label="sticky table">
						<MuiTableHead
							flag={true}
							columns={columns}
						/>
						<TableBody>
							{labels.map((label) => {
								return (
									<StyledTableRow
										hover
										role="checkbox"
										tabIndex={-1}
										key={label.labelId}
									>
										{columns.map((column) => {
											const value = label?.[column.id as keyof ClientLabelWithId]
											return (
												<TableCell
													key={column.id + label.labelId}
													align={column.align}
												>
													{value as ReactNode}
												</TableCell>
											)
										})}
										<TableCell align="center">
											<ClientLabelsActions clientLabel={label} />
										</TableCell>
									</StyledTableRow>
								)
							})}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<NoData />
			)}
		</Paper>

	)
}